export default "__VITE_ASSET__BqI5F6Fg__"